import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { twMerge } from 'tailwind-merge'
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { OnboardingTitle } from './OnboardingTitle'

import { Card, CardContent } from '@olino/design-system'

interface TypeCardProps {
  icon: IconDefinition
  name: string
  onClick: () => void
  disabled: boolean
}

export const TypeCard: React.FC<TypeCardProps> = ({ icon, name, onClick, disabled }) => (
  <button
    type="button"
    className="group h-full w-full focus:outline-none"
    key={name}
    onClick={onClick}
    disabled={disabled}
  >
    <Card className="h-full w-full transition group-hover:-translate-y-1 group-hover:bg-[#FAFAFA] group-hover:shadow-clone">
      <CardContent className="flex flex-col items-center gap-2">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-primary-50">
          <FontAwesomeIcon icon={icon} className={twMerge('h-6 w-6 text-primary-900 transition')} />
        </div>

        <div className="space-y-1">
          <OnboardingTitle.H3Products>{name}</OnboardingTitle.H3Products>
        </div>
      </CardContent>
    </Card>
  </button>
)
